/*!

=========================================================
* Paper Kit React - v1.3.2
=========================================================

* Product Page: https://www.creative-tim.com/product/paper-kit-react

* Copyright 2023 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/paper-kit-react/blob/main/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";

// reactstrap components
import { Container, Row, Col } from "reactstrap";

// core components
import { LoadScript, GoogleMap, Marker } from "@react-google-maps/api";

function SectionNucleoIcons() {
  // Note: For better responsiveness on small screens, consider adjusting map height dynamically
  // e.g., using viewport height units (vh) or CSS media queries.
  const mapStyles = {
    height: "400px", // This fixed height might be tall on small mobile screens
    width: "100%",
    borderRadius: "20px",
    overflow: "hidden"
  };

  const containerStyles = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    padding: "20px", // Keep padding consistent
    marginTop: "0" // Reduced margin-top for potentially better mobile layout
  };

  const marketLocation = {
    lat: 45.827504,
    lng: -77.1139491
  };

  // Ensure your Google Maps API Key is set in your .env file
  // REACT_APP_Maps_API_KEY=YOUR_API_KEY_HERE
  const apiKey = process.env.REACT_APP_Maps_API_KEY;

  return (
    <>
      {/* Added pt-5 pb-5 for padding, adjust as needed */}
      <div className="section section-dark section-nucleo-icons pt-5 pb-5">
        <Container>
          <Row>
            {/* Text Column */}
            <Col lg="6" md="12" className="d-flex align-items-center mb-4 mb-lg-0"> {/* Added flex alignment and bottom margin for mobile */}
              <div style={{
                backgroundColor: 'rgba(0, 0, 0, 0.3)',
                padding: '30px',
                borderRadius: '10px',
                width: '100%', // Ensure div takes full column width
                
              }}>
                <h2 className="title">Meet Us at the Market!</h2>
                <br />
                <h5 className="description"> {/* Used description class for consistency */}
                  Come explore the best of Pembroke's local flavours and creativity! Grab a coffee, meet our amazing vendors and experience the joy of shopping fresh & local.
                </h5>
                <h5 className="description mt-3"> {/* Added margin-top */}
                  Corner of Lake Street & Victoria Street, Pembroke, Ontario
                </h5>
                <h5 className="description mt-3"> {/* Added margin-top and corrected time */}
                  Market Days & Hours: Wednesdays & Saturdays 9 AM - 1 PM
                  <br/> {/* Added line break */}
                  Rain or Shine! Thanks to our covered market space.
                </h5>
              </div>
            </Col>
            {/* Map Column */}
            <Col lg="6" md="12" >
              <div className="icons-container" style={{marginTop: '30px',containerStyles}}>
                {apiKey ? (
                  <LoadScript googleMapsApiKey={apiKey}>
                    <GoogleMap
                      mapContainerStyle={mapStyles}
                      zoom={16}
                      center={marketLocation}
                    >
                      <Marker
                        position={marketLocation}
                        title="Pembroke Farmers' Market"
                      />
                    </GoogleMap>
                  </LoadScript>
                ) : (
                  <p className="text-warning">Google Maps API Key not configured. Map cannot be displayed.</p>
                )}
              </div>
            </Col>
          </Row>
        </Container>
      </div>{" "}
    </>
  );
}

export default SectionNucleoIcons;